module.exports = __webpack_public_path__ + "static/pallavi2-c8d55d5677e7275c0946e89c1263894e.jpg";